'use client'

import { createRef, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import generateGa4EcommerceRelatedProjectItem from 'src/helpers/google-tag-manager/scroll-bound/similar-listing-search';
import { GTMPushEvent } from 'helpers/google-tag-manager';
import setSearchId from 'src/helpers/google-tag-manager/set-search-id';
import { gtmLoadInterval } from 'src/helpers/google-tag-manager/gtm-load-interval';

import Container from 'src/components/grid/container';
import HighlighterListingProjectCard from 'components/homepage/highlighter-card/project-card';

import styles from './styles.module.css';

const ProjectDetailRelatedProjects = ({ relatedProjects }) => {
  const elementsRef = useRef(relatedProjects?.map(() => createRef()));
  const seenElements = useRef([]);

  const handleIntersection = (entries) => {
  entries.forEach((entry) => {
    const { isIntersecting } = entry;
    if (!isIntersecting) return;

    const id = entry.target.getAttribute('data-listing-card-index');
    const isElementSeen = seenElements.current.includes(id);
    if (isElementSeen) return;

    seenElements.current.push(id);
    const item = relatedProjects[id];
    const query = {
      item,
      index: id,
      searchId: setSearchId('projectdetail'),
      listName: 'proje-detay/benzer-projeler',
    };
    const gtmItem = generateGa4EcommerceRelatedProjectItem(query);

    gtmLoadInterval(() => {
      GTMPushEvent({ ecommerce: null });
      GTMPushEvent({
        event: 'view_item_list',
        ecommerce: {
          items: [gtmItem],
        },
      });
    });
  });
};

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => handleIntersection(entries), // Callback ayrı bir fonksiyona taşındı
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    }
  );

  elementsRef.current.forEach((element) => {
    observer.observe(element.current);
  });

  return () => {
    elementsRef.current.forEach((element) => {
      observer.unobserve(element.current);
    });
  };
}, [relatedProjects]); 


  return (
    <div className={styles.container}>
      <Container>
        <div className={styles.wrapper}>
          <p className={styles.title}>Bölgedeki Projeler</p>
          <div className={styles.projectCards}>
            {relatedProjects?.map((project, index) => (
                <div key={index} ref={elementsRef.current[index]} data-listing-card-index={index}>
              <HighlighterListingProjectCard key={index} listItemInfo={project} isProjectDetail />
          </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

ProjectDetailRelatedProjects.propTypes = {
  relatedProjects: PropTypes.array,
};

export default ProjectDetailRelatedProjects;
